import { Axios } from 'commonUtils';

class ProjectMergeApi {
  static runMerge = async ({
    projectFrom,
    projectTo,
    parentFolder,
    folder,
    origins = {},
    cockpits = {},
    connections = {},
    importObjects = true,
    importData = true,
    addAppInstall = false,
  }) => {
    return await Axios.post('/spr/project-merge', {
      projectFrom,
      projectTo,
      parentFolder,
      folder,
      origins,
      cockpits,
      connections,
      importObjects,
      importData,
      addAppInstall,
    });
  };

  static checkForConflicts({ projectFrom, projectTo, parentFolder, folder, importObjects = true, importData = true }) {
    return Axios.getData('/spr/project-merge/check-conflicts', {
      params: {
        projectFrom,
        projectTo,
        parentFolder,
        folder,
        importObjects,
        importData,
      },
    });
  }
}

export default ProjectMergeApi;
